import { useState } from "react";
import BasicLayout from "./BasicLayout";
import ModalHorizon from "components/modal";
import { SOURCE_TYPES } from "utils/constants";
import EasyListBox from "components/EasyListBox";
import InputField from "components/fields/InputField";
import ValidationIcon from "components/ValidationIcon";
import MacAddressesInput from "components/input/MacAddressesInput";
import { activationStates, serverSizes } from "variables/activations";
import CicleExclamationIcon from "components/icons/CicleExclamationIcon";
import { Tooltip, TooltipContent, TooltipTrigger } from "components/MyTooltip";

const Step7 = ({
    state,
    setState,
    message,
    cluster,
    available,
    backupAvailable,
}) => {
    const source = state?.data?.source;

    const handleChange = (event) => {
        const name = event.target.name;
        const value = event.target.value;
        setState((state) => ({
            ...state,
            data: {
                ...state.data,
                [name]: value,
            },
        }));
    };

    const [modal, setModal] = useState({
        active: false,
        title: null,
        description: null,
    });

    function closeModal() {
        setModal((previousState) => {
            return {
                ...previousState,
                active: false,
                title: null,
                description: null,
            };
        });
    }

    return (
        <>
            <ModalHorizon
                title={modal.title}
                description={modal.description}
                isOpen={modal.active}
                onClose={closeModal}
            />

            <BasicLayout
                title={"Server" + (cluster ? " master e backup" : "")}
                content={
                    <div>
                        <div className="-mt-4 flex flex-col gap-3">
                            <div className="info-box">
                                <strong>
                                    Sei già in possesso del codice server?
                                    Ottimo.
                                </strong>
                                <br />
                                Inserisci il codice server, l’IP della macchina
                                e il MAC Addresses nei campi qui sotto.
                                <br />
                                La macchina verrà attivata in automatico, non
                                appena la tua richiesta verrà approvata.
                            </div>

                            <div className="info-box">
                                <strong>
                                    Non sei in possesso del codice server?
                                </strong>
                                <br />
                                Nessun problema. <br />
                                Puoi mandare avanti il tuo ordine di
                                attivazione.
                                <br />
                                Quando il server sarà pronto, potrai riprendere
                                l’ordine e completare la procedura di
                                attivazione.
                            </div>

                            <div className="info-box">
                                <strong>
                                    Ti serve il codice server? Segui queste
                                    istruzioni per ottenerlo.
                                </strong>
                                <br />
                                <ol className="ml-4 list-decimal">
                                    <li> Collegati al pannello “Admin”</li>
                                    <li> Clicca sulla sezione "Avanzate"</li>
                                    <li>
                                        Posizionati su "Configurazione Sistema”
                                    </li>
                                    <li>
                                        Cerca la tabella "Generale", individua
                                        il campo “Codice Server”.
                                    </li>
                                </ol>
                                <br />
                                <span className="text-[14.5px] text-gray-800 dark:text-white">
                                    Il Codice Server viene generato in
                                    automatico dal sistema entro 30 minuti dal
                                    primo avvio della macchina.
                                </span>
                            </div>

                            <div className="info-box">
                                <strong>
                                    Devi selezionare la Dimensione Server?
                                </strong>
                                <br />
                                Nessun problema.
                                <br />
                                Scegli l'opzione pi&ugrave; adatta in base al
                                numero di utenti che dovranno utilizzare il
                                sistema:
                                <br />
                                <ol className="ml-4 list-decimal">
                                    <li>
                                        <strong>Small:</strong> seleziona questa
                                        opzione se prevedi fino a 20 utenti.
                                    </li>
                                    <li>
                                        <strong>Medium:</strong> seleziona
                                        questa opzione se prevedi fino a 100
                                        utenti.
                                    </li>
                                    <li>
                                        <strong>Large:</strong> seleziona questa
                                        opzione se prevedi fino a 250 utenti.
                                    </li>
                                    <li>
                                        <strong>XL:</strong> utilizza questa
                                        opzione per tutti i tagli superiori.
                                    </li>
                                </ol>
                                <br />
                                <span className="text-[14.5px] text-gray-800 dark:text-white">
                                    <strong>⚠️ Nota</strong>
                                    <br />
                                    Queste indicazioni sono valide
                                    esclusivamente per le versioni virtuali.
                                    <br />
                                    Per le versioni hardware, la dimensione del
                                    server dovr&agrave; corrispondere al modello
                                    acquistato.
                                </span>
                            </div>
                        </div>

                        <div>
                            <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
                                <div className="-mx-2 mt-6 flex items-stretch">
                                    <div className="mx-2 flex-1">
                                        <InputField
                                            extra="mb-4"
                                            label="Codice Server"
                                            placeholder={
                                                source === SOURCE_TYPES.RESELLER
                                                    ? "codice server"
                                                    : "codice server (se in possesso)"
                                            }
                                            name="server_code"
                                            type="text"
                                            disabled={available === true}
                                            value={state.data.server_code || ""}
                                            onChange={handleChange}
                                            required={
                                                source ===
                                                    SOURCE_TYPES.RESELLER ||
                                                state.status !==
                                                    activationStates.PENDING_COMPLETION
                                            }
                                            state={
                                                message.hasOwnProperty("errors")
                                                    ? message.errors.hasOwnProperty(
                                                          "data.server_code"
                                                      )
                                                        ? "error"
                                                        : null
                                                    : null
                                            }
                                            error={
                                                message.hasOwnProperty("errors")
                                                    ? message.errors.hasOwnProperty(
                                                          "data.server_code"
                                                      )
                                                        ? message.errors[
                                                              "data.server_code"
                                                          ]
                                                        : null
                                                    : null
                                            }
                                        />
                                    </div>

                                    {(available ||
                                        (message &&
                                            !!Object.keys(message).length)) && (
                                        <ValidationIcon available={available} />
                                    )}
                                </div>
                            </div>

                            {available === true && (
                                <div className="mb-4">
                                    <EasyListBox
                                        description={"Dimensione Server"}
                                        data={serverSizes}
                                        handleSelection={(value) => {
                                            handleChange({
                                                target: {
                                                    name: "size",
                                                    value: value,
                                                },
                                            });
                                        }}
                                        selected={state.data.size || ""}
                                        disabled={
                                            source === SOURCE_TYPES.RESELLER
                                                ? state?.data?.is_hw
                                                : false
                                        }
                                    />
                                </div>
                            )}

                            {available === true ? (
                                <div className="grid grid-cols-1 gap-5 pt-2 md:grid-cols-2">
                                    <div className="-mx-2 flex items-stretch">
                                        <div className="mx-2 flex-1">
                                            <InputField
                                                extra="mb-4"
                                                label={
                                                    "IP Macchina" +
                                                    (cluster ? " master" : "")
                                                }
                                                placeholder=""
                                                name="ip_server"
                                                type="text"
                                                disabled={true}
                                                value={
                                                    state.data.ip_server || ""
                                                }
                                                onChange={handleChange}
                                                required={
                                                    state.status !==
                                                    activationStates.PENDING_COMPLETION
                                                }
                                                state={
                                                    message.hasOwnProperty(
                                                        "errors"
                                                    )
                                                        ? message.errors.hasOwnProperty(
                                                              "data.ip_server"
                                                          )
                                                            ? "error"
                                                            : null
                                                        : null
                                                }
                                                error={
                                                    message.hasOwnProperty(
                                                        "errors"
                                                    )
                                                        ? message.errors.hasOwnProperty(
                                                              "data.ip_server"
                                                          )
                                                            ? message.errors[
                                                                  "data.ip_server"
                                                              ]
                                                            : null
                                                        : null
                                                }
                                            />
                                        </div>
                                        {state.data.ip_server !==
                                        state.data.ip_fqdn ? (
                                            <Tooltip>
                                                <TooltipTrigger>
                                                    <div className="mx-2 mt-3 shrink-0 self-center text-yellow-500">
                                                        <CicleExclamationIcon />
                                                    </div>
                                                </TooltipTrigger>

                                                <TooltipContent>
                                                    <div className="-mx-2 flex items-stretch">
                                                        <span className="mx-2 flex-1 dark:text-white">
                                                            L'IP macchina è
                                                            diverso dall'IP FQDN
                                                        </span>
                                                    </div>
                                                </TooltipContent>
                                            </Tooltip>
                                        ) : null}
                                    </div>

                                    <div className="col-span-12">
                                        <div className="info-box mb-6 max-w-[60%]">
                                            <div>
                                                Indirizzi MAC Macchina
                                                {cluster ? " master" : ""}{" "}
                                                (compilare solo le interfacce
                                                effettivamente presenti).
                                            </div>

                                            <div>
                                                I MAC address che vi chiediamo
                                                di inserire sono esclusivamente
                                                quelli delle schede di rete
                                                Ethernet, ovvero quelli
                                                identificati come{" "}
                                                <strong>eth</strong>.
                                            </div>
                                        </div>

                                        <MacAddressesInput
                                            placeholder={"f1:f1:f1:f1:f1:f1"}
                                            state={state}
                                            setState={setState}
                                            target={"mac_addresses"}
                                        />
                                    </div>
                                </div>
                            ) : null}
                        </div>

                        {cluster ? (
                            <div className="border-gray mt-4 border-t pt-3">
                                <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
                                    <div className="-mx-2 flex items-stretch">
                                        <div className="mx-2 flex-1">
                                            <InputField
                                                extra="mb-4"
                                                label="Codice Server backup"
                                                placeholder={
                                                    source ===
                                                    SOURCE_TYPES.RESELLER
                                                        ? "codice server backup"
                                                        : "codice server backup (se in possesso)"
                                                }
                                                name="server_code_backup"
                                                type="text"
                                                disabled={
                                                    backupAvailable === true
                                                }
                                                value={
                                                    state.data
                                                        .server_code_backup ||
                                                    ""
                                                }
                                                onChange={handleChange}
                                                required={
                                                    state.status !==
                                                    activationStates.PENDING_COMPLETION
                                                }
                                                state={
                                                    message.hasOwnProperty(
                                                        "errors"
                                                    )
                                                        ? message.errors.hasOwnProperty(
                                                              "data.server_code"
                                                          )
                                                            ? "error"
                                                            : null
                                                        : null
                                                }
                                                error={
                                                    message.hasOwnProperty(
                                                        "errors"
                                                    )
                                                        ? message.errors.hasOwnProperty(
                                                              "data.server_code"
                                                          )
                                                            ? message.errors[
                                                                  "data.server_code"
                                                              ]
                                                            : null
                                                        : null
                                                }
                                            />
                                        </div>

                                        {(available ||
                                            (message &&
                                                !!Object.keys(message)
                                                    .length)) && (
                                            <ValidationIcon
                                                available={backupAvailable}
                                            />
                                        )}
                                    </div>
                                </div>

                                {backupAvailable === true ? (
                                    <div className="mt-2 grid grid-cols-1 gap-5 pt-4 md:grid-cols-2">
                                        <div className="-mx-2 flex items-stretch">
                                            <div className="mx-2 flex-1">
                                                <InputField
                                                    extra="mb-4"
                                                    label="IP Macchina backup"
                                                    placeholder=""
                                                    name="ip_server_backup"
                                                    type="text"
                                                    disabled={false}
                                                    value={
                                                        state.data
                                                            .ip_server_backup ||
                                                        ""
                                                    }
                                                    onChange={handleChange}
                                                    required={
                                                        state.status !==
                                                        activationStates.PENDING_COMPLETION
                                                    }
                                                    state={
                                                        message.hasOwnProperty(
                                                            "errors"
                                                        )
                                                            ? message.errors.hasOwnProperty(
                                                                  "data.ip_server"
                                                              )
                                                                ? "error"
                                                                : null
                                                            : null
                                                    }
                                                    error={
                                                        message.hasOwnProperty(
                                                            "errors"
                                                        )
                                                            ? message.errors.hasOwnProperty(
                                                                  "data.ip_server"
                                                              )
                                                                ? message
                                                                      .errors[
                                                                      "data.ip_server"
                                                                  ]
                                                                : null
                                                            : null
                                                    }
                                                />
                                            </div>
                                            {state.data.ip_server_backup !==
                                            state.data.ip_fqdn ? (
                                                <Tooltip>
                                                    <TooltipTrigger>
                                                        <div className="mx-2 mt-3 shrink-0 self-center text-yellow-500">
                                                            <CicleExclamationIcon />
                                                        </div>
                                                    </TooltipTrigger>
                                                    <TooltipContent>
                                                        <div className="-mx-2 flex items-stretch">
                                                            <p className="mx-2 flex-1 dark:text-white">
                                                                L'IP macchina è
                                                                diverso dall'IP
                                                                FQDN
                                                            </p>
                                                        </div>
                                                    </TooltipContent>
                                                </Tooltip>
                                            ) : null}
                                        </div>

                                        <div className="col-span-12">
                                            <MacAddressesInput
                                                title={
                                                    "Indirizzi MAC Macchina backup (compilare solo le interfacce effettivamente presenti)"
                                                }
                                                placeholder={
                                                    "f1:f1:f1:f1:f1:f1"
                                                }
                                                state={state}
                                                setState={setState}
                                                target={"mac_addresses_backup"}
                                            />
                                        </div>
                                    </div>
                                ) : null}
                            </div>
                        ) : null}
                    </div>
                }
            />
        </>
    );
};

export default Step7;
